module.exports = __webpack_public_path__ + "static/fonts/iconfont.7bf38374.woff";